<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="PAGAMENTOS DE FORNECEDORES" :data="tableData" :dadosRel="dadosRel" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="6" :totalPDF="total - 1" titleReport="Relatório de Pagamentos">
                <md-button v-if="permissoes.relatoriosView" class="md-button md-site md-just-icon md-round" :to="{ name: 'relatoriosView' }">
                    <md-icon>assignment</md-icon>
                    <md-tooltip md-direction="top">Relatórios</md-tooltip>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout-item md-size-10 md-xsmall-size-100">
                            <md-field>
                                <label for="pages">Listar</label>
                                <md-select v-model="pagination.perPage" name="pages">
                                    <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                        {{ item }}
                                    </md-option>
                                </md-select>
                            </md-field>
                        </div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataInicial" md-immediately v-mask="'##/##/####'">
                                    <label>Data Inicial</label>
                                </md-datepicker>
                            </div>
                            <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataFinal" md-immediately v-mask="'##/##/####'">
                                    <label>Data Final</label>
                                </md-datepicker>
                            </div>
                            <div class="md-layout-item md-size-40 md-xsmall-size-100">
                                <md-field>
                                    <label>Pesquisar</label>
                                    <md-input type="search" class="mb-3" clearable placeholder="Cliente, Carro ou Placa" v-model="buscar.busca">
                                    </md-input>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-button @click="read()" class="md-site md-block md-round text-right md-sm">
                                    <md-icon>search</md-icon> BUSCAR
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell md-label="TIPO" style="width: 10%">{{ item.tipo }}</md-table-cell>
                        <md-table-cell md-label="CÓDIGO" style="width: 10%">{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="FORNECEDOR" style="width: 25%">{{ item.fornecedor }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CLIENTE / CARRO" style="width: 25%">{{ item.nome }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CPF / PLACA" style="width: 15%">{{ item.cpf_placa }}</md-table-cell>
                        <md-table-cell v-if="item.id" md-label="DATA" style="width: 10%">{{ item.data_pagamento }}</md-table-cell>
                        <md-table-cell v-if="!item.id" md-label="DATA" style="width: 10%"><strong>{{ item.data_pagamento }}</strong></md-table-cell>
                        <md-table-cell v-if="item.id" md-label="VALOR" style="width: 10%">{{ item.valor }}</md-table-cell>
                        <md-table-cell v-if="!item.id" md-label="VALOR" style="width: 10%"><strong>{{ item.valor }}</strong></md-table-cell>
                        <md-table-cell v-if="!item.id" md-label="AÇÕES" style="width: 5%"></md-table-cell>
                        <md-table-cell v-if="item.id" md-label="AÇÕES" style="width: 5%">
                            <md-menu md-direction="bottom-start" class="menuTable">
                                <md-button md-menu-trigger class="md-just-icon md-site md-round">
                                    <md-icon>menu</md-icon>
                                </md-button>

                                <md-menu-content>
                                    <md-menu-item v-if="permissoes.pagamentosCancel" @click="showSwal(item.id)">
                                        CANCELAR<md-icon class="text-danger">delete</md-icon>
                                    </md-menu-item>
                                    <md-menu-item @click="pagamento(item.id)">
                                        COMPROVANTE<md-icon class="text-info">grading</md-icon>
                                    </md-menu-item>
                                </md-menu-content>
                            </md-menu>

                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to - 1" :total="total - 1">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total - 1" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import Pagamento from '@/config/mixins/print/pagamento'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';
import Swal from "sweetalert2";

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {},
            detalhes: {},
            permissoes: this.$store.state.usuario.permissao,
            rotaDeletar: 'pagamentos/',
            rotaExcluir: 'pagamentos/excluir/',
            columnsPDF: [22, 15, 65, 30, 23, 25],
            headRowsPDF: ['TIPO', 'ID', 'CLIENTE / CARRO', 'CPF / PLACA', 'DATA', 'VALOR'],
            bodyRowsPDF: ['tipo', 'id', 'nome', 'cpf_placa', 'data_pagamento', 'valor'],
            fildsTXT: ['tipo', 'id', 'nome', 'cpf_placa', 'data_pagamento', 'valor_bd'],
            columnsExcel: [

                {
                    label: "TIPO",
                    field: "tipo",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "CLIENTE / CARRO",
                    field: "nome",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "CPF / PLACA",
                    field: "cpf_placa",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "DATA",
                    field: "data_pagamento"
                },
                {
                    label: "VALOR",
                    field: "valor_bd"
                },
            ],
            search: null,
            tableData: [],
            searchedData: [],
            dadosRel: [],
            buscar: {
                busca: '',
                dataInicial: null,
                dataFinal: null
            }
        };
    },

    mixins: [TableSearch, Notify, preLoader, Pagamento],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read(pagi) {
            this.buscar.situacao_id = this.dados.situacao_id
            let loader = this.openLoader('dots');
            pagi = pagi || this.$urlAPI + 'pagamentos/pagamento-fornecedor'
            this.$http.post(pagi, this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.dadosRel = response.data.lista
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.id, item.nome, item.cpf_placa, item.data_pagamento, item.valor]).includes(this.toLower(term)))
            }
            return items
        },

        pagamento(id) {
            const dataComprovante = this.searchedData.filter(function (item) {
                return item.id === id
            })
            this.printPagamento(dataComprovante[0])
        },

        showSwal(id) {
            Swal.fire({
                title: 'MOTIVO DA EXCLUSÃO',
                input: 'text',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: 'CANCELAR PAGAMENTO',
                cancelButtonText: 'SAIR',
                showLoaderOnConfirm: true,
                preConfirm: (text) => {
                    if (text == '' || text.length < 4) {
                        Swal.showValidationMessage(
                            'Digite um motivo de cancelamento válido.'
                        )
                    } else {
                        this.detalhes.id = id
                        this.detalhes.texto = text
                        this.cancel()
                    }
                },
            })
        },

        cancel() {
            this.$http.post(this.$urlAPI + 'pagamentos/cancelamento', this.detalhes)
                .then(response => {
                    if (response.data.status) {
                        this.success(response.data.message)
                        this.read()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },
    },
};
</script>
<style>
.md-layout-item {
    margin-top: 5px;
}
</style>
